import script from "./AdminLogs.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminLogs.vue?vue&type=script&setup=true&lang=js"

import "./AdminLogs.vue?vue&type=style&index=0&id=47a57358&scoped=true&lang=css"

import exportComponent from "/home/viction/eshopcommand/source/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47a57358"]])

export default __exports__